/**
 * Generated by orval v8.5.3 🍺
 * Do not edit manually.
 * Space Invoices API
 * REST API for invoice management, customer management, and accounting operations. Features include cursor-based pagination for efficient data navigation, flexible JSON querying with MongoDB-style operators, full-text search across multiple fields, and comprehensive metadata support for custom tracking.
 * OpenAPI spec version: 1.0.0
 */

/**
 * Item classification used for Portugal SAF-T item/service typing.
 * @nullable
 */
export type CreateItemBodyClassification = typeof CreateItemBodyClassification[keyof typeof CreateItemBodyClassification] | null;


export const CreateItemBodyClassification = {
  product: 'product',
  service: 'service',
  advance: 'advance',
} as const;
